


















































































































































































































































































import Vue from 'vue';
import Component from 'vue-class-component';
import * as PDT_INTERFACE from '../tickets-form/interfaces/PDT.interface';
import { getDate } from '@/modules/shared/shared/domain/functions/date-functions.ts';
import { loader, user, tickets } from '@/modules/shared/shared/store/namespaces';
import { EventBus } from '@/main';
import { EventBusMessages } from '@/modules/shared/shared/domain/constants/event-bus-messages';

@Component({})
export default class EquipmentDepartureSheet extends Vue {
    oldPDT: PDT_INTERFACE.PDTInterface = {} as PDT_INTERFACE.PDTInterface;

    date: string = 'Caracas, 30 de marzo de 2020';
    location: string = 'Centro Tecnológico Dayco CTDV';
    departureReason: string = 'Desincorporación';
    outsideTime: string = 'Permanente';
    authorizedContact: string = 'Anyelina Sottolano / Oreste Torres';
    owner: string = 'TRANRED';
    equipments: {
        description: string;
        measureUnit: string;
        quantity: number;
        brand: string;
        model: string;
        serial: string;
        lengthOfTransfer: string;
        destination: string | undefined;
        motive: string | undefined;
        concept: string | undefined;
    }[] = Array();

    departureDestiny: string | undefined = 'TRANSRED torre CARI';
    departureDestinyReason: string | undefined = 'entrega a proveedor';
    managerName: string = '';
    vpServicesSupervisor: string = '';
    managerJob: string = 'Centro de Servicios Daycohost';
    VPFinancesName: string = '';
    VPFinancesJob: string = 'Director de finanzas';
    customerName: string = '';
    responsiblePerson: string = '';
    customerCI: string = '6921683';
    customerPhone: string = '(212) 12 345 678';
    presidentName: string = '';
    async mounted() {
        try {
            EventBus.$emit(EventBusMessages.SHOW_LOADER);
            this.oldPDT = this.ticketDetail;
            this.mapPDTToForm(this.oldPDT);
            EventBus.$emit(EventBusMessages.HIDE_LOADER);
        } catch (error) {
            // console.warn(error)
        }
    }
    print() {
        window.print();
    }
    mapPDTToForm(oldPDT: PDT_INTERFACE.PDTInterface) {
        this.customerName = oldPDT.customer.name;
        oldPDT.creationDate == ''
            ? (this.date = getDate(new Date().toString()))
            : (this.date = getDate(oldPDT.creationDate));
        this.location = oldPDT.accessPermission.dataCenter.name;
        let responsiblePerson = this.getSpecificContact(1, oldPDT.accessPermission.accessContacts);
        this.authorizedContact = this.getFullName(responsiblePerson);
        this.owner = oldPDT.customer.name;
        this.equipments = this.getEquipments(oldPDT.accessPermission.accessPermissionEquipments);
        this.departureDestiny = oldPDT.accessPermission.accessPermissionEquipments[0].destination;
        this.departureDestinyReason =
            oldPDT.accessPermission.accessPermissionEquipments[0].departureMotive;
        this.responsiblePerson = this.getFullName(responsiblePerson);
        this.customerCI = this.getCI(responsiblePerson);
        this.customerPhone = this.getPhone(responsiblePerson);
    }

    getEquipments(accessPermissionEquipments: PDT_INTERFACE.accessPermissionEquipmentsInterface[]) {
        let equipments: {
            description: string;
            measureUnit: string;
            quantity: number;
            brand: string;
            model: string;
            serial: string;
            lengthOfTransfer: string;
            destination: string | undefined;
            motive: string | undefined;
            concept: string | undefined;
        }[] = Array();
        accessPermissionEquipments.forEach(item => {
            if (item.movementType.id == 2) {
                equipments.push({
                    description: item.accessEquipment.name,
                    measureUnit: item.accessEquipment.measureUnit,
                    quantity: 1,
                    brand: item.accessEquipment.brand,
                    model: item.accessEquipment.model,
                    serial: item.accessEquipment.serial,
                    lengthOfTransfer:
                        item.accessEquipmentDeparturePeriodType == 1
                            ? 'Salida Temporal'
                            : 'Salida Permanente',
                    destination: item.destination,
                    motive: item.departureMotive,
                    concept: item.accessEquipmentDepartureType.name,
                });
            }
        });
        return equipments;
    }

    getPhone(authorizedContact: PDT_INTERFACE.accessContactsInterface) {
        return authorizedContact.phone;
    }

    getCI(authorizedContact: PDT_INTERFACE.accessContactsInterface) {
        return authorizedContact.identification;
    }

    getFullName(authorizedContact: PDT_INTERFACE.accessContactsInterface) {
        return authorizedContact.name + ' ' + authorizedContact.lastName;
    }

    getSpecificContact(
        contactType: number,
        accessContacts: PDT_INTERFACE.accessContactsInterface[],
    ) {
        let authorizedContact: PDT_INTERFACE.accessContactsInterface = {} as PDT_INTERFACE.accessContactsInterface;
        accessContacts.forEach(contact => {
            if (contact.contactDetails.some(detail => detail.contactType.id == contactType)) {
                authorizedContact = contact;
            }
        });
        return authorizedContact;
    }

    @tickets.State('ticketDetail') ticketDetail;
}
